import { SimpleDialog } from 'components';
import { Grid, Button } from '@mui/material';
const CollectionMessageDg = (props) => {
  const { isOpenCollectionDG, setIsOpenCollectionDG } = props;
  return (
    <SimpleDialog fullWidth maxWidth="sm" open={isOpenCollectionDG} title="مشاهده کارت جمع">
      <Grid container style={{ textAlign: 'justify' }}>
        <div>
          برای مشاهده فایل حداقل 15 دقیقه بعد از ثبت درخواست، به درخواست کارتابلی مربوطه مراجعه
          فرمایید و از طریق دکمه "کارت جمع" فایل خروجی را مشاهده نمایید. لطفا توجه داشته باشید
          درصورتیکه درخواست بیشتر از یکبار در حداقل زمان اعلامی انجام شود، فرایند با مشکل روبرو
          خواهد شد.
        </div>
      </Grid>
      <Grid style={{ display: 'flex', marginTop: '16px', flexDirection:'row-reverse'}}>
        <Button
          variant="contained"
          onClick={() => setIsOpenCollectionDG(false)}
        >
          بستن
        </Button>
      </Grid>
    </SimpleDialog>
  );
};

export default CollectionMessageDg;
